import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { Composites, ColorPickerInput, TextLabel, ActionWithSymbol, } from '@wix/wix-base-ui';
import { FontPickerIcon } from './FontPickerIcon';
import { openColorPicker } from '../ColorPicker/openColorPicker';
import { openFontPicker } from './openFontPicker';
export function getFontDisplayName(presets, preset, customFontLabel) {
    if (!presets) {
        console.warn('Unable to get font display name as site presets have not yet loaded');
        return;
    }
    if (preset === 'Custom' || !preset) {
        return customFontLabel;
    }
    var font = presets[preset];
    return font && font.displayName ? font.displayName : customFontLabel;
}
export function getAppFontFromFontPicker(res) {
    var style = res.style, preset = res.preset, family = res.family, size = res.size;
    return {
        style: style,
        size: parseInt(size, 10),
        preset: res.displayName ? preset : 'Custom',
        family: family,
        fontStyleParam: res.fontStyleParam,
        htmlTag: res.htmlTag,
        value: '', // seems should be fill CSS font value, but we cut in FontPicker
    };
}
export function getFontForFontPicker(presets, font) {
    if (!font.preset || font.preset === 'Custom') {
        return font;
    }
    return presets[font.preset]
        ? __assign({ editorKey: presets[font.preset].editorKey }, font) : __assign({}, font);
}
var BaseFontAndColorPicker = /** @class */ (function (_super) {
    __extends(BaseFontAndColorPicker, _super);
    function BaseFontAndColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleColorPickerRef = function (ref) {
            _this.colorPickerRef = ref;
        };
        _this.handleFontPickerRef = function (ref) {
            _this.fontPickerRef = ref;
        };
        _this.handleOpenFontPicker = function () {
            var _a = _this.props, SDKAdapter = _a.SDKAdapter, font = _a.font, fontPickerTitle = _a.fontPickerTitle, fontPickerOptions = _a.fontPickerOptions, onFontChange = _a.onFontChange;
            var position = _this.getFontPickerPositionOfPicker();
            openFontPicker(SDKAdapter, {
                font: font,
                fontPickerTitle: fontPickerTitle,
                fontPickerOptions: fontPickerOptions,
                onFontChange: onFontChange,
                position: position,
            });
        };
        _this.handleOpenColorPicker = function () {
            var _a = _this.props, SDKAdapter = _a.SDKAdapter, onColorChange = _a.onColorChange, onSiteColorsChange = _a.onSiteColorsChange, color = _a.color;
            var position = _this.getColorPickerPositionOfPicker();
            openColorPicker(SDKAdapter, {
                value: color,
                onChange: onColorChange,
                onSiteColorsChange: onSiteColorsChange,
                position: position,
            });
        };
        _this.state = {
            presets: null,
        };
        return _this;
    }
    BaseFontAndColorPicker.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.setState;
                        _b = {};
                        return [4 /*yield*/, this.props.SDKAdapter.getSiteTextPresets()];
                    case 1:
                        _a.apply(this, [(_b.presets = _c.sent(),
                                _b)]);
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseFontAndColorPicker.prototype.getColorPickerPositionOfPicker = function () {
        var dom = ReactDOM.findDOMNode(this.colorPickerRef);
        return dom.getBoundingClientRect();
    };
    BaseFontAndColorPicker.prototype.getFontPickerPositionOfPicker = function () {
        var dom = ReactDOM.findDOMNode(this.fontPickerRef);
        return dom.getBoundingClientRect();
    };
    BaseFontAndColorPicker.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, label = _a.label, font = _a.font, color = _a.color, _b = _a.customFontLabel, customFontLabel = _b === void 0 ? 'Custom' : _b;
        return (React.createElement("div", { "data-aid": dataHook, "data-hook": dataHook },
            React.createElement(Composites.LinkButtonWithColorInputLabeled, { automationId: "font-and-color-picker" },
                React.createElement(TextLabel, { value: label, automationId: "label" }),
                React.createElement(Composites.LinkButtonWithColorInput, null,
                    React.createElement(ActionWithSymbol, { action: this.handleOpenFontPicker, symbol: React.createElement(FontPickerIcon, null), ref: this.handleFontPickerRef },
                        React.createElement("label", { "data-aid": "font-label" }, getFontDisplayName(this.state.presets, font.preset, customFontLabel))),
                    React.createElement(ColorPickerInput, { value: color.value, ref: this.handleColorPickerRef, onClick: this.handleOpenColorPicker })))));
    };
    return BaseFontAndColorPicker;
}(React.Component));
export { BaseFontAndColorPicker };
//# sourceMappingURL=BaseFontAndColorPicker.js.map